import React, { useMemo } from "react";
import ReactECharts from "echarts-for-react";
import { useThemeMode } from "../../context/ThemeContext";

export function PieChart({ data = [] }) {
  const { mode } = useThemeMode();

  const option = useMemo(() => {
    return {
      darkMode: mode === "black",
      tooltip: { trigger: "item" },
      legend: { bottom: 0 },
      series: [
        {
          type: "pie",
          radius: ["40%", "70%"],
          data,
          label: { formatter: "{b}: {d}%" },
        },
      ],
    };
  }, [data, mode]);

  return <ReactECharts option={option} style={{ height: 260 }} />;
}
